module.exports = __webpack_public_path__ + "img/content-with-img-links-cjdr.06a45d4b.jpg";